import { PaymentServiceAccountStatus } from "@clipboard-health/contract-worker-app-bff";
import { WorkerStage } from "@clipboard-health/contract-worker-app-bff";

import { Address } from "./address";
import { LegacyGeoLocationCoordinatesAndType } from "./util";

/*
  TODO: Most, if not all of these types should be moved to the appV2/Worker/api/types.ts file and be inferred from their corresponding zod schemas.
*/

interface AgentOnboardingFlags {
  isSignupInitiated?: boolean;
  isSignupCompleted?: boolean;
  signupStage?: string | null;
}

interface License {
  number?: string;
  expires?: string;
  state?: string;
}

interface AgentAttendance {
  sortMeta?: 0 | 1;
  completedShifts: number;
  cancelledShifts?: number;
  totalShifts?: number;
  consecutive?: number;
  consecutiveCancels?: number;
  percentage?: number;
  updatedAt?: string;
}

interface AgentRequirement {
  requirement?: string;
  expires?: string;
}

interface AgentUploads {
  requirement?: string;
  status?: string;
}

interface Specialities {
  experience?: string[];
  hasSedationExperience?: boolean;
  hasTrayAssemblyExperience?: boolean;
}

interface AgentRating {
  count?: number;
  value?: number;
}

interface NotificationPreference {
  off: boolean; // deprecated field
  push: boolean;
  email: boolean;
  sms: boolean;
  marketingPush: boolean;
  marketingEmail: boolean;
  marketingSMS: boolean;
  long_code_sms: boolean; // deprecated field
  urgentShiftNotification?: {
    isOn: boolean;
  };
  priorityAccessPush?: boolean;
  placementsMarketingPush?: boolean;
}

interface AgentPreference {
  distance?: number;
  qualification?: string;
}

export enum CONTRACTOR_AGREEMENT_VERSIONS {
  V1 = "V1",
  V2 = "V2",
  V3 = "V3",
  V4 = "V4",
  V5 = "V5",
}
interface ContractorAgreement {
  agreementVersion: CONTRACTOR_AGREEMENT_VERSIONS;
  signedDate: string;
  fullName?: string | null;
}

interface BackgroundCheckApplication {
  applicationType?: string;
  candidateId?: string;
}
interface Mobile {
  openedAt?: Date;
  version?: string;
  build?: number;
  platform?: string;
  isLocationServicesEnabled?: boolean;
  locationServicesPermission?: string;
}

interface IAgentLicensesData {
  qualification: string;
  state: string;
  multiState: boolean;
  expiresAt?: Date;
}

interface IOpenNegotiationsCount {
  totalNegotiatingShiftsCount: number;
  negotiationsWaitingOnWorker: number;
}

/*
@deprecated Use Worker instead
*/
interface Agent {
  _id?: string;
  active?: boolean;
  userId?: string;
  name?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  email?: string;
  qualification?: string;
  geoLocation?: LegacyGeoLocationCoordinatesAndType;
  address?: Address;
  specialities?: Specialities;
  license?: License;
  hideAsColleagueOnShifts?: boolean;
  onboardingFlags?: AgentOnboardingFlags;
  socialSecurityNumber?: string;
  noCallNoShow?: number;
  attendance?: AgentAttendance;
  requirements?: AgentRequirement[];
  profileImageUrl?: string;
  isProfilePictureUploaded?: boolean;
  rating?: AgentRating;
  /**
   * This is always defined from the server, even during onboarding.
   */
  stage?: WorkerStage;
  referralCode?: string;
  rate?: number;
  uploads?: AgentUploads[];
  isFirstSession?: boolean;
  isNotificationAlertShown?: boolean;
  applicantId?: string;
  signupExperimentId?: string;
  signupConfig?: {
    signingBonusAmount1?: number;
    signingBonusAmount2?: number;
    eventName?: string;
  };
  hasClaimedBonus?: boolean;
  notificationPreferences?: NotificationPreference;
  status?: number;
  phoneNumber?: string | number;
  onboardAt?: string;
  lastLogAt?: string;
  preference?: AgentPreference;
  canBeOnboardedInStripe?: boolean;
  alreadyOnboarded?: boolean;
  dob?: string;
  paymentAccountInfo?: PaymentAccountInfo;
  tmz?: string;
  alreadyWorked?: boolean;
  referralCodeUsed?: {
    code: string;
    createdAt: Date;
    referredBonusId?: string;
    referrerBonusId?: string;
    referrer: string;
  };
  signedContractorAgreements?: ContractorAgreement[];
  backgroundCheckApplications?: BackgroundCheckApplication[];
  mobile?: Mobile;
  isTestAccount?: boolean;
  requestedAccountDeletion?: {
    requested: boolean | null;
    createdAt: Date | null;
    previousStage: WorkerStage | null;
  };
  licensesData?: IAgentLicensesData[];
  negotiationsCount?: IOpenNegotiationsCount;
  createdAt?: string;
}

interface PaymentAccountInfo {
  _id: string;
  accountId: string;
  createdAt: string;
  enabled: boolean;
  enabledAt: string;
  updatedAt: string;
  autoWithdrawEnabled: boolean;
  withdrawalFee: number;
  status: PaymentServiceAccountStatus;
  gatewayTransferDisabled: boolean;
}

type SignUpStatus = "inprogress" | "complete" | "unstarted" | "unknown";

export type {
  Agent,
  License,
  Specialities,
  PaymentAccountInfo,
  SignUpStatus,
  IAgentLicensesData,
  AgentOnboardingFlags,
};
